var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":_vm.id,"listening":_vm.fullData},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }